// extracted by mini-css-extract-plugin
export default {"input":"TableInput_input__f8WbQ","td":"TableInput_td__UhRvJ"};